<template>
  <!-- 地区号选择弹窗 -->
  <van-popup
    :value="showPopup"
    position="bottom"
    @input="showPopup = $event"
    style="border-top-left-radius: 16px;border-top-right-radius: 16px;"
  >
    <div>
      <div class="title">{{$t(`选择国家及地区`)}}</div>
      <div class="popup-content">
        <!-- 搜索框 -->
        <div class="search-box">
          <van-search v-model="searchKeyword" :placeholder="$t(`搜索国家和地区`)" />
        </div>
        <!-- 首字母导航 -->
        <div class="index-bar">
          <div
              v-for="letter in indexLetters"
              :key="letter"
              :class="['index-letter', activeLetter === letter ? 'active' : '']"
              @touchstart="scrollToLetter(letter)"
          >
            {{ letter }}
          </div>
        </div>
        <!-- 国家列表 -->
        <div style="max-height: 60vh;overflow-y: auto;position: relative;">
          <van-index-bar
              class="country-index-bar"
              ref="indexBar"
              @change="onChange"
          >
            <div
                v-for="(group, letter) in groupedCountries"
                :key="letter"
            >
              <van-index-anchor class="index-anchor-box" :index="letter" style="padding: 0" />
              <div
                  class="cell"
                  v-for="country in group"
                  :key="country.id"
                  @click="selectCountry(country)"
              >
                <img :src="country.img" style="width: 22px;height: 22px;border-radius: 50%;"  alt="" />
                <div style="margin: 0 16px;">{{ country.name }}</div>
                <div>+{{ country.code }}</div>
              </div>
            </div>
          </van-index-bar>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import { Cell, Popup, Field, IndexBar, IndexAnchor, Search } from 'vant';
import axios from "axios";
export default {
  props: {

  },
  components: {
    [Cell.name]: Cell,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Search.name]: Search
  },
  data() {
    return {
      showPopup: false,
      searchKeyword: '',
      countryList: [],
      selectedCountry: {},
      scrollTop: 0,
      // 存储滚动条位置与字母的映射关系
      scrollPositions: {},
      activeLetter: ''
    };
  },
  computed: {
    // 获取所有首字母
    indexLetters() {
      const letters = Object.keys(this.groupedCountries);
      // 对字母进行排序
      return letters.sort((a, b) => a.localeCompare(b));
    },

    // 按首字母分组
    groupedCountries() {
      const groups = {};

      // 过滤搜索内容
      const filteredList = this.countryList.filter(country => {
        return (
            country.name && country.name.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
            country.code.includes(this.searchKeyword)
        );
      });

      // 按首字母分组
      filteredList.forEach(country => {
        const firstLetter = country.name && country.name.charAt(0).toUpperCase();
        if (firstLetter && /[A-Z]/.test(firstLetter)) {
          if (!groups[firstLetter]) {
            groups[firstLetter] = [];
          }
          groups[firstLetter].push(country);
        }
      });

      // 确保返回的 groups 是按 A-Z 排序的对象
      const sortedGroups = {};
      const sortedKeys = Object.keys(groups).sort((a, b) => a.localeCompare(b, 'en'));

      sortedKeys.forEach(key => {
        sortedGroups[key] = groups[key];
      });

      return sortedGroups;
    }
  },
  created() {
    this.getCountries();
  },
  methods: {
    getCountries() {
      axios.post("/api/st-auth/newuser/getAreaCodes").then((res) => {
        this.countryList = res.data.data;
      });
    },
    // 滚动到指定字母的位置
    scrollToLetter(letter) {
      // 使用 vant 的 van-index-bar 自带的滚动方法
      console.log(this.$refs.indexBar)
      console.log(this.$refs.indexBar.scrollTo)
      this.$refs.indexBar.scrollTo(letter);
    },

    // 选择国家
    selectCountry(country) {
      this.selectedCountry = country;
      this.showPopup = false;
      // 触发事件，通知父组件已选择国家
      this.$emit('select', country);
    },
    onChange(letter) {
      this.activeLetter = letter;
    }
  }
};
</script>
<style lang="less" scoped>
.title{
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  padding: 16px 20px 16px;
  border-bottom: 1px solid #EDEEF0;
}
.popup-content {
  padding: 16px;
  max-height: 100%;
  overflow-y: auto;
  font-size: 14px;
}

.search-box {
  margin-bottom: 6px;
  /deep/.van-search{
    padding: 10px 0;
  }
}

.index-bar {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3;
}

.index-letter {
  font-size: 12px;
  color: #333;
  text-align: center;
  width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 2px 8px;
  &.active{
    color: #29D769;
  }
}
.index-anchor{
  line-height: 32px;
  color: #29D769;
  position: sticky;
  top: 0;
}
.cell{
  display: flex;
  align-items: center;
  padding: 12px 16px;
  &:not(:last-child){
    border-bottom: 1px solid #f5f5f5;
  }
}
.index-anchor-box{
  /deep/.van-index-anchor{
    font-weight: 600;
    background-color: #f7f8fa;
  }
  /deep/.van-index-anchor--sticky{
    color: #29D769;
    font-weight: 600;
    background-color: #fff;
  }
}
.country-index-bar{
  /deep/.van-index-bar__sidebar{
    opacity: 0;
  }
}
</style>
